<div role="banner" *ngIf="outcome" class="height-100per">
  <div class="left-nav height-100per">
    <div class="navBrand">
      <div [class.sticky-header]="!pdfBackup" [class.searchMarginBottom]="true">
        <div tabindex="0" (keyup.enter)="loginPageredirect()" class="mainLogo" (click)="loginPageredirect()"><img [src]="logo" [class.cursor-pointer]="!pdfBackup" alt="Logo Image"></div>
        <div tabindex="0" class="search_Goto_margin pt-4" *ngIf="!pdfBackup">
          <div class="flex-display Gotosizing">
            <form [formGroup]="GoToFormGroup" class="pr-0-75rem pb-0-5rem">
              <mat-form-field class="background-white width-8rem" appearance="fill">
                <input #autoCompleteInput matInput class="font-14-imp itcBookFont" type="text" formControlName="goToText" (input)="applyGoToFilter($event.target.value)" placeholder="Ex. 740-10-25-1" (keyup.enter)="GoToPage()" [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete" class="min-width-6-5rem gotoscroll">
                <mat-option *ngFor="let option of leftNavSuggestions" [value]="option" class="font-12"
                  (click)="suggestedGoToValue(option)">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
              </mat-form-field>
              </form>
              <button mat-button class="goToButton_padding">
                <div class="goToButton"
                  (click)="GoToPage()">
                  Go To</div>
              </button> 
          </div>
          <div>
            <mat-error class="mat-field-hint width-513px" *ngIf="SearchTextError != ''"> {{SearchTextError}}</mat-error>
          </div>
           
        </div>
        <div tabindex="0" class="navElement" *ngIf="!pdfBackup" [class.selectedFirstNavElement]="isSearchClicked && highlight == undefined" (click)="selectedIndexLevel1 = 100;isSearchClicked = true; popupRedirect(x,2)" (keyup.enter)="selectedIndexLevel1 = 100;isSearchClicked = true; popupRedirect(x,2)">
          <img class="navLogo" [src]="searchIcon" alt="Search/Go To">
          <div class="navName">
            {{searchLabel }}
          </div>
        </div>
      </div>
    </div>
    <div class="left-menu-container" data-message="FASB Left Navigation" aria-label="Left Navigation"  *ngIf="!pdfBackup" role="navigation">
      <div #navLevel1>
        <div *ngFor="let obj of tempData, index as i" tabindex="0" class="navElement" [class.spaceOnBottom]="obj.spaceOnBottom" [class.spaceOnTop]="obj.spaceOnTop" [class.subNavDisabledElement]="(obj.itemData.length == 0 && obj.itemLink == null &&obj.item =='My ASC' )" [class.ml36px]="(obj.itemData.length == 0 && obj.itemLink == null &&obj.item =='My ASC' )" [class.selectedFirstNavElement]="((l2State == 'in') ? i === selectedIndexLevel1 : obj.item === area)" (click)="selectedIndexLevel1 = i;highlight=i; navClicked(obj,1)" (keyup.enter)="selectedIndexLevel1 = i;highlight=i; navClicked(obj,1)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowRight)="nextLevel(1)">
          <img *ngIf="obj.logoSrc != null && obj.item != 'Logout' && obj.itemData.length != 0" class="navLogo" [src]="obj.logoSrc" [alt]="obj.item">
          <img *ngIf="obj.logoSrc != null && obj.item != 'Logout' && obj.itemData.length == 0 && obj.itemLink == null &&obj.item =='My ASC'" class="navLogo" src="../../../assets/icons/User-disabled.svg" [alt]="obj.item">
          <img *ngIf="obj.item == 'Logout'" class="navLogo" src="../../../assets/icons/logout-white.svg" alt="Logout Icon" [alt]="obj.item">
          <div class="navName">
            {{obj.item}}
          </div>
          <div *ngIf="obj.itemData.length > 0" class="m-Auto">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="flag" #navLevel2 class="menu-overlay-level-2  fullComponent" [class.z-index-negative]="menuIndexNegativeArr[0]" [@slideInOut]="l2State"
    (@slideInOut.done)="animationDone(l2State,0)" (@slideInOut.start)="animationStart(l2State,0)">
    <div class="fullComponent">
      <div class="searchBox">
        <div class="pt-80px">
          <div class="searchtext white-color">{{searchtext}}</div>
          <div class="flex-display">
            <mat-form-field class="width-80 whitecolor" floatLabel="never">
              <input #autoCompleteInput matInput type="text" [(ngModel)]="searchText" (input)="applyFilter($event.target.value);fetchSuggestion($event.target.value)" (keyup.enter)="searchComponentRedirection()"
                class="searchinput" [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of autoSuggestion" [value]="option.text"
                  (click)="suggestedValue(option.text)">
                  {{option.text}}
                </mat-option>
              </mat-autocomplete>
              <mat-placeholder class="searchinput">{{enterText}}</mat-placeholder>
            </mat-form-field>
            &nbsp;
            <button mat-button>
              <div [ngClass]="searchText ? 'accept-search-result' : 'showallbutton'"
                (click)="searchComponentRedirection()">
                {{showButton}}</div>
            </button>
          </div>
        </div>
        <div class="pb-2rem">
          <div class="font-16 answer pt-1-25 white-color" [innerHTML]="text" *ngIf="searchText == ''"></div>
          <div class="font-16 navName pt-1-25 white-color" *ngIf="searchText == ''">{{hereExample}}</div>
          <div class="font-16 navName pt-1-25 white-color" *ngIf="searchText == ''">
            <div class="pt-10">{{example1}}</div>
            <div class="pt-10">{{example2}}</div>
          </div>
        </div>
      </div>
      <div *ngIf="searchText != '' && searchText != null" class="searchSuggestion"
        [ngClass]="(category>0)?'pb-2rem':'pb-20per'">
        <div>
          <div class="showing-top-results pb-2rem">{{topResults}} {{searchText}}</div>
          <div class="flex-display">
            <div class="pt-1-25 pr-3 width-22">
              <span class="searchtable">{{sectionHeader}}</span>
              <div class="ptb-18">
                <div *ngFor="let paraRecord of top5ParaRecords" class="pb-2rem">
                  <div class="searchResultElement ptb-10"
                    *ngIf="paraRecord.source.topicId != null && paraRecord.source.topicTitle != null && paraRecord.source.subtopicId != null && paraRecord.source.subtopicTitle != null && paraRecord.source.sectionId != null && paraRecord.source.sectionTitle != null">
                    <div class="itcBookFont font-14" (click)="redirectToUrl(paraRecord.source)">
                      <span>{{paraRecord.source.topicId}}&nbsp;{{paraRecord.source.topicTitle}} <img
                          src="../../../assets/icons/Arrow-right-white.svg"
                          class="search-bread-crumb-icon bread-crumb-Arrow itcBookFont" alt="Arrow Right"> </span>
                      <span>{{paraRecord.source.subtopicId}}&nbsp;{{paraRecord.source.subtopicTitle}}</span>
                      <span class="openSansSemiBoldFont font-18 underline"><span class="font-18 openSansSemiBoldFont">
                        <img src="../../../assets/icons/Arrow-right-white.svg"
                          class="search-bread-crumb-icon bread-crumb-Arrow"
                          alt="Arrow Right">{{paraRecord.source.sectionId}}&nbsp;{{paraRecord.source.sectionTitle}}</span></span>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-1-25 pr-3 width-22">
              <span class="searchtable">{{topicsHeader}}</span>
              <div class="ptb-18">
                <div *ngFor="let topicRecord of top5TopicRecords">
                  <div class="white-color ptb-10"
                    *ngIf="topicRecord.source.topicId != null && topicRecord.source.topicTitle != null">
                    <div class="pb-24px"><span
                        class="font-16 itcBookFont">{{topicRecord.source.topicId}}</span>&nbsp;<span
                        class="font-16 itcBookFont">{{topicRecord.source.topicTitle}}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-1-25 pr-3 width-22">
              <span class="searchtable">{{glossaryToolsHeader}}</span>
              <div class="ptb-18">
                <div class="pb-24px" *ngFor="let glossary of glossaryResult">
                  <div class="itcBookFont font-16 white-color ptb-10 flex-display">
                    <span><img src="../../../assets/icons/OpenBook-white.svg" class="close-icon-image mr-5"
                        alt="Glossary Icon"></span>&nbsp;<span class="font-16 navName" [innerHtml]="glossary.source.title"></span>
                  </div>
                </div>
                <div class="pb-24px" *ngFor="let annotation of annotationResult">
                  <div class="itcBookFont font-16 white-color ptb-10 flex-display">
                    <div><img src="../../../assets/icons/pencil-white.svg" class="close-icon-image mr-5" alt="Annotation">
                    </div>
                    &nbsp;<div class="font-16 navName">{{annotation.annotationTitle}}<br /><span
                        class="font-14 navName">{{annotation.createdOn.split(" ")[0]}}</span></div>
                  </div>
                </div>
                <div class="pb-24px " *ngFor="let bookmark of bookmarkResult">
                  <div class="itcBookFont font-16 white-color ptb-10 flex-display">
                    <span><img src="../../../assets/icons/bookmark-home-white.svg" class="close-icon-image mr-5"
                        alt="Bookmark"></span>&nbsp;<span class="font-16 navName">{{bookmark.bookmarkTitle}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-1-25 pr-3 width-22">
              <span class="searchtable">{{otherSourceHeader}}</span>
              <div class="ptb-18">
                <div *ngFor="let otherSourceRecord of top5OtherSourceRecords">
                  <div class="white-color ptb-10 searchResultElement" (click)="redirectToUrl(otherSourceRecord.source)"
                    *ngIf="otherSourceRecord.source.title != null">
                    <div class="pb-24px"><span
                        class="font-16 itcBookFont">{{otherSourceRecord.source.title}}</span></div>
                  </div>
                </div>

                <div *ngFor="let pdfRecord of top5PdfRecords">
                  <div class="white-color ptb-10 searchResultElement" (click)="openSitesPdf(pdfRecord.source.title)"
                    *ngIf="pdfRecord.source.title != null && pdfRecord.source.attachment.title!=null">
                    <div class="pb-24px">
                      <span><img src="../../../assets/icons/PDF_icon.svg" class="pdf-icon-image mr-5"
                      alt="Glossary Icon"></span>&nbsp;<span
                        class="font-16 itcBookFont">{{pdfRecord.source.attachment.title}}</span></div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!flag" #navLevel2 class="menu-overlay-level-2" [class.z-index-negative]="menuIndexNegativeArr[0]" [@slideInOut]="l2State" (@slideInOut.done)="animationDone(l2State,0)" (@slideInOut.start)="animationStart(l2State,0)">
   <div class="fullComponent">
      <div class="nav-level-overflow nav-level-2" *ngIf="(selectedIndexLevel1 || selectedIndexLevel1 === 0) && tempData[selectedIndexLevel1]?.itemData?.length > 0 ">
        <div class="space-div"></div>
        <div class="mb-5">
          <div *ngFor="let obj of tempData[selectedIndexLevel1].itemData, index as i" tabindex="0" [class.subNavElement]="(!(obj.itemData.length == 0 && obj.itemLink == null))" [class.subNavDisabledElement]="(obj.itemData.length == 0 && obj.itemLink == null)" [class.selectedNavElement]="i === selectedIndexLevel2 && (!(obj.itemData.length == 0 && obj.itemLink == null))" (click)="selectedIndexLevel2 = i; navClicked(obj,2)" (keyup.enter)="selectedIndexLevel2 = i; navClicked(obj,2)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowLeft)="previousLevel(2)" (keyup.arrowRight)="nextLevel(2)">
            <div role="navigation" aria-label="{{obj.item}}" class="navName">
              <div class="flex-display" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && tempData[selectedIndexLevel1].item != 'Tools' && tempData[selectedIndexLevel1].item != 'My ASC'">
                <div><strong>{{obj.item.split(" ")[0]}}&nbsp;&nbsp;</strong></div><div>{{obj.item.replace(obj.item.split(" ")[0], "")}}</div>
              </div>          
              <div *ngIf="tempData[selectedIndexLevel1].item == 'Other Sources' || tempData[selectedIndexLevel1].item == 'Tools' || tempData[selectedIndexLevel1].item == 'My ASC'">
                {{obj.item}}
              </div>
            </div>
            <div *ngIf="obj.itemData.length > 0" class="m-Auto">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div #navLevel3 class="menu-overlay-level-3" [class.z-index-negative]="menuIndexNegativeArr[1]" [@slideInOut]="l3State" (@slideInOut.done)="animationDone(l3State,1)" (@slideInOut.start)="animationStart(l3State,1)">
    <div class="fullComponent">
      <div class="nav-level-overflow nav-level-3" *ngIf="selectedIndexLevel2 || selectedIndexLevel2 === 0 && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData.length>0">
        <div class="space-div"></div>
        <div class="mb-5">
          <div *ngFor="let obj of tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData, index as i">
            <div *ngIf="obj.isIndustryChanged" class="industry-specific">Shared Subtopics</div>
            <div tabindex="0" [class.subNavElement]="(!(obj.itemData.length == 0 && obj.itemLink == null))" [class.subNavDisabledElement]="(obj.itemData.length == 0 && obj.itemLink == null)" [class.selectedNavElement]="i === selectedIndexLevel3 && (!(obj.itemData.length == 0 && obj.itemLink == null))" (click)="selectedIndexLevel3 = i; navClicked(obj,3)" (keyup.enter)="selectedIndexLevel3 = i; navClicked(obj,3)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowLeft)="previousLevel(3)" (keyup.arrowRight)="nextLevel(3)">
              <div role="navigation" aria-label="{{obj.item}}" class="navName">
                <div class="flex-display" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && tempData[selectedIndexLevel1].item != 'Tools' && tempData[selectedIndexLevel1].item != 'My ASC'">
                  <div><strong>{{obj.item.split(" ")[0]}}&nbsp;&nbsp;</strong></div><div>{{obj.item.replace(obj.item.split(" ")[0], "")}}</div>
                </div>
                <div *ngIf="tempData[selectedIndexLevel1].item == 'Other Sources' || tempData[selectedIndexLevel1].item == 'Tools' || tempData[selectedIndexLevel1].item == 'My ASC'">
                  {{obj.item}}
                </div>
              </div>
              <div *ngIf="obj.itemData.length > 0" class="m-Auto">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </div>
            </div>
            <div class="subNavElement" (click)="showAllInOnePage(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2])" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && showAllInOneRequiredOn3rdLevel && obj.afterShowAllInOnePageRequired">
              <div class="m-Auto">
                <mat-icon>filter_none</mat-icon>
              </div>&nbsp; &nbsp;
              <div class="navName">
                Show All in One Page
              </div>
            </div>
          </div>

          <div class="subNavElement" (click)="showAllInOnePageIncludeSharedSubtopics(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2])" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[0].itemLink == null && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData.length - 1].afterShowAllInOnePageRequired == null">
            <div class="m-Auto">
              <mat-icon>filter_none</mat-icon>
            </div>&nbsp; &nbsp;
            <div class="navName">
              Show All in One Page <span class="font-14">(including Shared Subtopics)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div #navLevel4 class="menu-overlay-level-4" [class.z-index-negative]="menuIndexNegativeArr[2]" [@slideInOut]="l4State" (@slideInOut.done)="animationDone(l4State,2)" (@slideInOut.start)="animationStart(l4State,2)">
    <div class="fullComponent">
      <div class="nav-level-overflow nav-level-4" *ngIf="selectedIndexLevel3 || selectedIndexLevel3 === 0 && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData != null">
        <div class="space-div"></div>
        <div class="mb-5">
          <div *ngFor="let obj of tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData, index as i">
            <div *ngIf="obj.isIndustryChanged" class="industry-specific">Shared Subtopics</div>
            <div tabindex="0" [class.subNavElement]="(!(obj.itemData == null && obj.itemLink == null))" [class.subNavDisabledElement]="(obj.itemData == null && obj.itemLink == null)" [class.selectedNavElement]="i === selectedIndexLevel4 && (!(obj.itemData == null && obj.itemLink == null))" [ngClass]="(!showSecContent && obj.isSecContent==true)?'display-none':'flex-display'" (click)="selectedIndexLevel4 = i;navClicked(obj,4)" (keyup.enter)="selectedIndexLevel4 = i;navClicked(obj,4)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowLeft)="previousLevel(4)">
              <div role="navigation" aria-label="{{obj.item}}" class="navName ">
                <div class="flex-display" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && tempData[selectedIndexLevel1].item != 'Tools' && tempData[selectedIndexLevel1].item != 'My ASC'">
                  <div><strong>{{obj.item.split(" ")[0]}}&nbsp;&nbsp;</strong></div><div>{{obj.item.replace(obj.item.split(" ")[0], "")}}</div>
                </div>
                <div *ngIf="tempData[selectedIndexLevel1].item == 'Other Sources' || tempData[selectedIndexLevel1].item == 'Tools' || tempData[selectedIndexLevel1].item == 'My ASC'">
                  {{obj.item}}
                </div>
              </div>
              <div *ngIf="obj.itemData != null" class="m-Auto">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </div>
            </div>
            <div *ngIf="!showSecContent">
              <div class="subNavElement" (click)="showAllInOnePage(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3])" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && (obj.afterShowAllInOnePageRequired)">
                <div class="m-Auto">
                  <mat-icon>filter_none</mat-icon>
                </div>&nbsp; &nbsp;
                <div class="navName">
                  Show All in One Page
                </div>
              </div>
            </div>
            <div *ngIf="showSecContent">
              <div class="subNavElement" (click)="showAllInOnePage(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3])" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && obj.afterShowAllInOnePageRequired">
                <div class="m-Auto">
                  <mat-icon>filter_none</mat-icon>
                </div>&nbsp; &nbsp;
                <div class="navName">
                  Show All in One Page
                </div>
              </div>
            </div>
          </div>

          <div class="subNavElement" (click)="showAllInOnePageIncludeSharedSubtopics(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3])" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData[0].itemLink == null && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData[tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData.length - 1].afterShowAllInOnePageRequired == null">
            <div class="m-Auto">
              <mat-icon>filter_none</mat-icon>
            </div>&nbsp; &nbsp;
            <div class="navName">
              Show All in One Page <span class="font-14">(including Shared Subtopics)</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div #navLevel5 class="menu-overlay-level-5" [class.z-index-negative]="menuIndexNegativeArr[3]" [@slideInOut]="l5State" (@slideInOut.done)="animationDone(l5State,3)" (@slideInOut.start)="animationStart(l5State,3)">
    <div class="fullComponent">
      <div class="nav-level-overflow nav-level-5" *ngIf="selectedIndexLevel4 || selectedIndexLevel4 === 0 && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData[selectedIndexLevel4].itemData != null">
        <div class="space-div"></div>
        <div class="mb-5">
          <div *ngFor="let obj of tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData[selectedIndexLevel4].itemData, index as i" tabindex="0" class="subNavElement" [ngClass]="(!showSecContent && obj.isSecContent==true)?'display-none':'flex-display'"  [class.selectedNavElement]="i === selectedIndexLevel5" (click)="selectedIndexLevel5 = i;navClicked(obj,5)" (keyup.enter)="selectedIndexLevel5 = i;navClicked(obj,5)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowLeft)="previousLevel(5)">
            <div role="navigation" aria-label="{{obj.item}}" class="navName ">
              <div class="flex-display" *ngIf="tempData[selectedIndexLevel1].item != 'Other Sources' && tempData[selectedIndexLevel1].item != 'Tools' && tempData[selectedIndexLevel1].item != 'My ASC'">
                <div><strong>{{obj.item.split(" ")[0]}}&nbsp;&nbsp;</strong></div><div>{{obj.item.replace(obj.item.split(" ")[0], "")}}</div>
              </div>
              <div *ngIf="tempData[selectedIndexLevel1].item == 'Other Sources' || tempData[selectedIndexLevel1].item == 'Tools' || tempData[selectedIndexLevel1].item == 'My ASC'">
                {{obj.item}}
              </div>
            </div>
          </div>
          <div class="subNavElement" (click)="showAllInOnePage(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData[selectedIndexLevel4])">
            <div class="m-Auto">
              <mat-icon>filter_none</mat-icon> 
            </div>&nbsp; &nbsp;
            <div class="navName">
              Show All in One Page
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bread-crumb-overlay" [class.z-index-negative]="menuIndexNegativeArr[0]" *ngIf="isSearchClicked == false" [@slideInOut]="l2State" (@slideInOut.done)="animationDone(l2State,0)" (@slideInOut.start)="animationStart(l2State,0)">
    <div *ngIf="crumbData.length > 0" class="nav-footer-bread-crumb-container">
      <div *ngFor="let obj of crumbDataNav, index as i" class="nav-bread-crumb">
        <div role="navigation" aria-label="{{obj}}" class="bread-crumb-text">
          {{obj}}
        </div>
        <div>
          <mat-icon [inline]="true" class="nav-bread-crumb-icon">arrow_forward</mat-icon>
        </div>
      </div>
    </div>
  </div>


  <div [@slideInOut]="btnState" role="navigation" aria-label="btnStateNavigation" [tabindex]="btnState === 'in' ? 0 : -1" data-message="close navigation" [class.z-index-negative]="menuIndexNegativeArr[0]" class="close-nav-layout" (click)="closeNav()" (keyup.enter)="closeNav()" (keydown.Tab)="closeNav()">
    <button id="close-nav-button" tabindex="-1" mat-raised-button class="close-nav-btn">
      Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Left Navbar">
    </button>
  </div>

